import axios from 'axios'

const asyncLoading = {
  data: () => ({
    loading: true,
    siteData: {}
  }),
  props: {
    fromSite: {
      type: String,
      required: true
    }
  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      try {
        vm.$_setLoading()

        const reply = await axios.get(`https://europe-west1-quamm-gdpr-38d1e.cloudfunctions.net/sites/info/${vm.fromSite}`)
        vm.$data.siteData = reply.data.siteData
      } catch (e) {
        vm.$router.push({ name: 'not-found', params: { locale: 'it' } })
      } finally {
        vm.$_setLoaded()
      }
    })
  },
  methods: {
    $_setLoading () {
      this.loading = true
      this.$emit('loading')
    },
    $_setLoaded () {
      this.loading = false
      this.$emit('loaded')
    }
  }
}

export default asyncLoading
